// export const roles = [
//     'appz_sales',
//     'appz_support',
//     'appz_finance',
//     'merchant_admin',
//     'psp_admin',
//     'appz_admin'
//
// ];
export const roles = {
    appz: {
        id: 1,
        name: 'appz',
        systemRole: 'appz'
    },
    merchant: {
        id: 2,
        name: 'merchant',
        systemRole: 'merchant'
    },
    psp: {
        id: 3,
        name: 'psp',
        systemRole: 'psp'
    },
    agent: {
        id: 8,
        name: 'agent',
        systemRole: 'agent'
    }
};

export const hiddenFieldsConfig = {
    [roles.appz.name]: {
        hideFields: []
    },
    [roles.merchant.name]: {
        hideFields: []
    },
    [roles.psp.name]: {
        hideFields: []
    },
    [roles.agent.name]: {
        hideFields: []
    }
};
